import { useMount } from 'ahooks';
import { useAtom } from 'jotai';
import { queryCartCountAtom } from '@/atoms';

export const useQueryCartCount = () => {
  const [cartCount, queryCartCount] = useAtom(queryCartCountAtom);

  return {
    cartCount,
    queryCartCount,
  };
};

export const useCartCount = () => {
  const { cartCount, queryCartCount } = useQueryCartCount();

  useMount(queryCartCount);

  return {
    cartCount,
  };
};
